export default [
  {
    path: "usuarios",
    name: "usuario",
    component: () =>
      import(/* webpackChunkName: "gestionUsuarios" */ "./usuarios.vue"),
  },
];
